import { useEffect, useState } from 'react';
import { fetchRecommendations } from '../api/justWatch';
import { getChannel, getTitle, Row } from './engine';

export const MODEL_ROW_ID = 'recommended-for-you';
export const MODEL_ROW_TITLE = 'Recommended For You — Just Watch AI';

export type ModelRowStatus = 'loading' | 'ready' | 'error';

export function useModelRow(userId: string, n = 8): { row: Row | null; status: ModelRowStatus } {
  const [row, setRow] = useState<Row | null>(null);
  const [status, setStatus] = useState<ModelRowStatus>('loading');

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');
    setRow(null);

    fetchRecommendations(userId, n)
      .then((recs) => {
        if (cancelled) return;
        const items = recs
          .map((r) => {
            const title = getTitle(r.title_id);
            if (!title) return null;
            return {
              title,
              channel: getChannel(title.channel_id),
              reason: r.explanation.summary,
              bars: r.explanation.bars,
              note: r.explanation.note,
            };
          })
          .filter((item): item is NonNullable<typeof item> => item !== null);

        setRow({ id: MODEL_ROW_ID, title: MODEL_ROW_TITLE, items });
        setStatus('ready');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [userId, n]);

  return { row, status };
}
